export function mergeArraysUnique<T>(currentOptions: T[], newOptions: T[]) {
  return Array.from(new Set([...currentOptions, ...newOptions]));
}
export function removeDuplicates<T>(arr: T[]) {
  return arr.filter((item, index) => arr.indexOf(item) === index);
}
